// Copyright (c) 2024-2026 Echonum LLC. All rights reserved.
// Product: Exploit Score ETS (Exploit Threat Score)
// Version: 2.0.4
//
// This file is part of Exploit Score ETS, proprietary software developed by
// Echonum LLC. Unauthorized copying, distribution, modification, or use of
// this file, via any medium, is strictly prohibited without express written
// permission from Echonum LLC.
//
// Confidential and Proprietary.

import { Outlet } from 'react-router-dom'
import Sidebar from './Sidebar'
import Header from './Header'

export default function Layout() {
  return (
    <div className="min-h-screen flex bg-dark-bg">
      <Sidebar />
      <div className="flex-1 flex flex-col min-h-screen">
        <Header />
        <main className="flex-1 p-6 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
